import { useHistory } from 'react-router-dom';

export const useRoutingHelpers = () => {
  const history = useHistory();
  const pathname =
    history && history.location ? history.location.pathname : null;

  const goToModalPath = path => {
    history.push(`${pathname}${path}`);
  };
  const goToPath = path => {
    history.push(path);
  };
  return {
    goToModalPath,
    goToPath,
  };
};
